import React, { useEffect } from 'react';

const containerStyle = {
  maxWidth: '1100px',
  margin: '140px auto 40px auto',
  padding: '32px 24px',
  textAlign: 'left',
  background: '#fff',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
};

const headingStyle = {
  color: '#3d3479',
  marginBottom: '0.5em'
};

const sectionTitleStyle = {
  fontWeight: 700,
  fontSize: '1.2em',
  marginTop: '2em',
  marginBottom: '0.5em'
};

const listStyle = {
  paddingLeft: '1.5em',
  marginBottom: '1em'
};

function TermsOfService() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Terms of Service</h1>
      <div style={{ color: '#666', marginBottom: '2em' }}>Last updated: June 2024</div>

      <div>
        <div style={sectionTitleStyle}>1. Acceptance of Terms</div>
        <p>
          By accessing or using MusicTeachers.ai ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Service. These Terms apply to all visitors, users, and others who access or use the Service.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>2. Use of Service</div>
        <ul style={listStyle}>
          <li>You must be at least 18 years old to use this Service.</li>
          <li>You agree to provide accurate, current, and complete information when registering or using the Service.</li>
          <li>You are responsible for maintaining the confidentiality of your account and password and for restricting access to your device.</li>
          <li>You agree to notify us immediately of any unauthorized use of your account or any other breach of security.</li>
        </ul>
      </div>

      <div>
        <div style={sectionTitleStyle}>3. Intellectual Property</div>
        <p>
          All content, trademarks, service marks, logos, data, and materials on this website, including but not limited to software, databases, text, graphics, icons, and hyperlinks, are the property of MusicTeachers.ai or its licensors. You may not use, reproduce, distribute, or create derivative works from any content without our express written permission.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>4. Prohibited Conduct</div>
        <ul style={listStyle}>
          <li>You may not use the Service for any unlawful or unauthorized purpose.</li>
          <li>You may not attempt to gain unauthorized access to any part of the Service, accounts, or networks connected to the Service.</li>
          <li>You may not interfere with or disrupt the Service, servers, or networks connected to the Service.</li>
          <li>You may not use the Service to transmit any viruses, malware, or other harmful code.</li>
          <li>You may not use automated means to access the Service without our prior written consent.</li>
        </ul>
      </div>

      <div>
        <div style={sectionTitleStyle}>5. Termination</div>
        <p>
          We reserve the right to suspend or terminate your access to the Service at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties. Upon termination, your right to use the Service will immediately cease.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>6. Disclaimer</div>
        <p>
          The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the Service will be uninterrupted, secure, or error-free. Your use of the Service is at your sole risk.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>7. Limitation of Liability</div>
        <p>
          To the fullest extent permitted by law, MusicTeachers.ai and its affiliates, officers, employees, agents, partners, and licensors shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (a) your use or inability to use the Service; (b) any unauthorized access to or use of our servers and/or any personal information stored therein; (c) any interruption or cessation of transmission to or from the Service.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>8. Changes to Terms</div>
        <p>
          We may update these Terms of Service from time to time. We will notify users of any material changes by posting the new Terms on this page. Continued use of the Service after such changes constitutes acceptance of the new Terms. We encourage you to review these Terms periodically.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>9. Governing Law</div>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which MusicTeachers.ai operates, without regard to its conflict of law provisions.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>10. Contact Us</div>
        <p>
          If you have any questions about these Terms, please contact us at <a href="mailto:info@musicteachers.ai">info@musicteachers.ai</a>.
        </p>
      </div>
    </div>
  );
}

export default TermsOfService;
